import { render, staticRenderFns } from "./AnswerChoicesVertical.vue?vue&type=template&id=38c8ae8a&scoped=true&"
import script from "./AnswerChoicesVertical.vue?vue&type=script&lang=js&"
export * from "./AnswerChoicesVertical.vue?vue&type=script&lang=js&"
import style0 from "./AnswerChoicesVertical.vue?vue&type=style&index=0&id=38c8ae8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8ae8a",
  null
  
)

export default component.exports